import CONFIG from '../config';

/*** Gets the gaming list redirect with selected filter
 *
 * @param countryCode  country to redirect to
 * @param accessFilter access filter to start enabled
 */
export const getSeeAllGamesLink = ( countryCode: string, accessFilter?: string): string => {
  return `${CONFIG.isUPC ? '/upc' : ''}${countryCode === 'uk' ? '' : `/${countryCode}`}/ubisoftplus/games?${(accessFilter !== undefined) ? '&access=' + accessFilter : ''}`
};

/*** Redirects the user correctly on whether  the user is on upc or store
 *
 * @param Link for the redirection
 */
export function redirectUser(link:string){
  if (CONFIG.isUPC) {
    window.location.href = link;
  } else {
    let win = window.open(link, '_blank');
    win.focus();
  }
}


/*** Get the right link from the key passed in Google Sheet
 *
 * @param countryCode : Country code used for redirection
 * @param key : Key that determines which link to redirect to
 */
export const getNavigationPageLink = (key:string) => {
  let parsedCountryCode = CONFIG.countryCode === 'uk' ? '' : `${CONFIG.countryCode}/`;
  //Different link for ncsa
  let isDifferentLink =  CONFIG.isUPC && (CONFIG.countryCode === 'us' || CONFIG.countryCode === 'ca');
  const LANDING_PAGE_LINK = `/${CONFIG.isUPC ? 'upc/' : ''}${parsedCountryCode}ubisoftplus`;
  const GAMES_LINK = `${CONFIG.isUPC ? '/upc' : ''}${CONFIG.countryCode === 'uk' ? '' : `/${CONFIG.countryCode}`}/ubisoftplus/games`;
  const REWARDS_LINK = `/${CONFIG.isUPC ? 'upc/' : ''}${parsedCountryCode}ubisoftplus${isDifferentLink ? '-' : '/'}rewards`;
  const CLOUD_GAMING_LINK = `/${CONFIG.isUPC ? 'upc/' : ''}${parsedCountryCode}ubisoftplus${isDifferentLink ? '-' : '/'}cloud`;

  switch (key) {
    case 'landing':
      return LANDING_PAGE_LINK;
    case 'games' :
      return GAMES_LINK;
    case 'rewards' :
      return REWARDS_LINK;
    case 'cloud' :
      return CLOUD_GAMING_LINK;
    default:
      break;
  }
};